import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Newsletter Drafts',
  basePath: '/newsletter-draft',
  columns: [
    { key: 'date', label: 'Date', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'user_name', label: 'User', sortable: true },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
  ],
  rowActions: [
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  defaultSort: { field: 'date', dir: 'desc' },
});
